export default {
    CHANGE_LANG(state, lang) {
        state.langSelected = lang;
        localStorage.setItem('app_lang', lang);
    },
    SET_DASHBOARD_OPTIONS (state, options) {
        state.options = Object.assign({}, state.options, options);
    },

    SET_MENU_ACTIVATED (state, menuIndex){
        state.menuActivated = menuIndex;
    },

    CREATE_MENU_OPTION_INDEX (state, {key, value}){
        state.menuOptionIndexed[key] = value;
    },

    SET_LOADING_START (state) {
        state.loadingState = true;
    },

    SET_LOADING_END (state) {
        state.loadingState = false;
    },

    SET_ONLINE (state) {
        state.status.online = true;
    },

    SET_OFFLINE (state) {
        state.status.online = false;
    },

    SET_UPDATE_STATUS (state, updateValue) {
        state.status.update = updateValue;
    },

    SET_FOCUS_STATUS (state, focusValue) {
        state.status.focused = focusValue;
    },

    SET_DATASTORE_VERSION(state, value){
        state.dataStoreVersion = value;
    },

    DONT_RETRY_STATUS(state){
        state.hasStatusAvailable = false;
    },

    ALLOW_BURGER_MENU (state, value) {
        state.burger.allowed = value;
    },
    CHANGE_BURGER_MENU_STATUS (state, value) {
        state.burgerClosed = value;
        if (value == true)
            localStorage.setItem('menuClosed', 'true');
        else
            localStorage.setItem('menuClosed', 'false');
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/store/mutations.js
// module id = null
// module chunks = 